import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import HeaderWrapper from '../HeaderWrapper';
import AutoSuggestInput from '../../../atomic/Inputs/AutoSuggestInput';

const HeaderWrapperStyled = styled(HeaderWrapper)`
  background: #eee;
  border: 1px solid #ccc;
`

class ChipSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }

  handleChange = value => {
    const { onChange, header, field, limit } = this.props;

    if (limit && value.length >= limit) {
      return;
    }

    // an alternate approach would be to pass in parameters for replace call
    // i.e. something like a transform property which would not be field specific
    if (header === "Tags" || field === "Tags") {
      const hashtag = /^#+/;
      value = value.map(item => ({ label: item.label.replace(hashtag, ''), value: item.value.replace(hashtag, '') }));
    }

    onChange(value);
    // this.setState({ selectedArray: value });
  };

  render() {
    const { limit, options, value, onChange, ...other } = this.props;

    return (
      <HeaderWrapperStyled {...other}>
        <AutoSuggestInput
          fullWidth
          options={options}
          onChange={this.handleChange}
          defaultValue={value}
          limit={limit}
        />
      </HeaderWrapperStyled>
    )
  }
}

ChipSelect.propTypes = {
  options: PropTypes.array.isRequired,
  limit: PropTypes.number,
};

ChipSelect.defaultProps = {

};

export default ChipSelect;
